import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { CancelAction, CancelGetter } from '@/store/cancel/cancel.module';
import { Cancel } from '@/store/cancel/cancel.model';
import { ProjectAttachment } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectCancelAttachmentModelComponent',
  components: {
    BaseModalComponent
  },
  props: {
    projectId: {
      type: Number,
    }
  },
  emits: [
    'upload',
    'hidden',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const cancel = computed<Cancel>(() => store.getters[CancelGetter.GET]);
    const attachments = computed<ProjectAttachment[]>(() => (cancel.value) ? cancel.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[CancelGetter.STATUS] === 'init' || store.getters[CancelGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', props.projectId);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(CancelAction.REMOVE_ATTACHMENTS, {
              projectId: props.projectId,
              attachmentIds: [id],
            });
          }
        });
    };

    // hidden
    const handleHidden = () => {
      context.emit('hidden', props.projectId);
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
      handleHidden,
    };
  },
});
